import { useEffect, useRef } from "react";
import RecentlyListedTable from "../../components/ebayListings/recentlyListed/RecentlyListedTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import RecentlyListedStats from "../../components/ebayListings/recentlyListed/RecentlyListedStats";


export default function RecentlyListed() {
  const { setInfo } = usePageNameContext();
  const errorClickHandlerRef = useRef<((errorMessage: string) => void) | null>(null);

  useEffect(() => {
    setInfo({
      name: "eBay Recently Listed Items",
      desc: "View parts that were listed in the last 90 days",
    });
  }, []);

  return (
    <div className="flex flex-col gap-y-4 mt-4">
      <RecentlyListedStats onErrorClick={(errorMessage) => {
        errorClickHandlerRef.current?.(errorMessage);
      }} />
      <RecentlyListedTable 
        onErrorClickRef={errorClickHandlerRef}
      />
    </div>
  )
}